import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { finalize, fromEvent, takeUntil, tap } from 'rxjs'

import { DestroyService } from '@app/core/services/destroy.service'
import { DeviceInstallation } from '@app/shared/models/device.model'
import { DevicesService } from '@app/shared/modules/devices/devices.service'

@Component({
  selector: 'lin-import-assignments-dialog',
  templateUrl: './import-assignments-dialog.component.html',
  styleUrls: ['./import-assignments-dialog.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class ImportAssignmentsDialogComponent implements OnInit {
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>
  isUploading = false
  fileErrors = null
  successfulUploaded = false
  displayedColumns: string[] = ['row', 'errors']

  constructor(
    private readonly dialogRef: MatDialogRef<ImportAssignmentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: DeviceInstallation,
    private devicesService: DevicesService,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    const fileInput = this.fileInput.nativeElement

    fromEvent(fileInput, 'click')
      .pipe(takeUntil(this.destroyService))
      .subscribe(() => {
        this.fileInput.nativeElement.value = ''
        this.fileErrors = null
      })

    fromEvent(fileInput, 'change')
      .pipe(takeUntil(this.destroyService))
      .subscribe(() => this.import(fileInput.files))
  }

  clearInputValue(): void {
    this.fileInput.nativeElement.value = ''
  }

  import(file: FileList): void {
    this.isUploading = true

    this.devicesService
      .importDeviceAssignFile(file)
      .pipe(
        tap(({ data }) => {
          const fileErrors = data.filter((row) => row.errors)
          if (fileErrors.length) {
            this.fileErrors = fileErrors
            this.clearInputValue()
          } else {
            this.successfulUploaded = true
          }
        }),
        takeUntil(this.destroyService),
        finalize(() => (this.isUploading = false)),
      )
      .subscribe()
  }

  close() {
    this.dialogRef.close(true)
  }
}
